// extracted by mini-css-extract-plugin
module.exports = {"iconSync":"ResultDeal_iconSync__3Fg7O","fa-spin":"ResultDeal_fa-spin__1qDg1","iconInfo":"ResultDeal_iconInfo__2SEWO"};